import { Badge } from "@/components/ui/badge/badge";

/** As stored on a check-in, check-out, login or logout (see the API's utils/officeNetwork). */
export type NetworkNote = {
  officeNetwork?: boolean | null;
  serverIp?: string | null;
};

/**
 * Where a check-in or check-out came from, as the server saw it: the office's
 * internet provider (Solanki Fibre) or somewhere else. Only for super admins;
 * nothing is ever refused. Records from before it was noted show a dash.
 */
export const NetworkBadge = ({ officeNetwork, serverIp, label }: NetworkNote & { label?: string }) => {
  if (officeNetwork === undefined || officeNetwork === null) {
    return (
      <span
        className="text-xs text-muted-foreground"
        title="Recorded before the network was noted"
        data-testid="network-badge"
        data-network="unknown"
      >
        {label ? `${label}: —` : "—"}
      </span>
    );
  }

  const text = officeNetwork ? "Solanki" : "Outside";
  const where = officeNetwork
    ? "The office's internet provider (Solanki Fibre)"
    : "Not the office's internet provider";

  return (
    <Badge
      variant={officeNetwork ? "outline" : "destructive"}
      title={serverIp ? `${where} · ${serverIp}` : where}
      data-testid="network-badge"
      data-network={officeNetwork ? "office" : "outside"}
    >
      {label ? `${label}: ${text}` : text}
    </Badge>
  );
};
